app.base = {};

app.base.attachmentHelper = require('./components/base/AttachmentHelper.vue').default;
app.base.messageListBase = require('./components/base/MessageListBase.vue').default;
app.base.listBase = require('./components/base/ListBase.vue').default;
app.base.showBase = require('./components/base/ShowBase.vue').default;
app.base.editBase = require('./components/base/EditBase.vue').default;
app.base.formSubmissionBase = require('./components/forms/FormSubmissionBase.vue').default;
app.base.threadListNew = require('./components/thread/ThreadListNew.vue').default;

var patientList = require('./components/generic/GenericList.vue').default;
var patientShow  = require('./components/generic/GenericShow.vue').default;
var patientEdit  = require( './components/generic/GenericEdit.vue').default;

var staffList = require('./components/generic/GenericList.vue').default;
var staffShow  = require( './components/generic/GenericShow.vue').default;
var staffEdit  = require( './components/generic/GenericEdit.vue').default;

var userDuplicateList = require('./components/generic/GenericList.vue').default;
var userDuplicateShow = require( './components/generic/GenericShow.vue').default;
var userDuplicateEdit = require( './components/generic/GenericEdit.vue').default;

var newsList = require('./components/generic/GenericList.vue').default;
var newsShow  = require( './components/generic/GenericShow.vue').default;
var newsEdit  = require( './components/generic/GenericEdit.vue').default;

var tagList = require('./components/tags/TagList.vue').default;
var tagShow = require('./components/tags/TagShow.vue').default;
var tagEdit = require('./components/tags/TagEdit.vue').default;

var customActionList = require('./components/custom_actions/CustomActionList.vue').default;
var customActionShow = require('./components/custom_actions/CustomActionShow.vue').default;
var customActionEdit = require('./components/custom_actions/CustomActionEdit.vue').default;

var cohortList = require('./components/cohorts/List.vue').default;
var cohortShow = require('./components/cohorts/Show.vue').default;
var cohortEdit = require('./components/cohorts/Edit.vue').default;

var campaignList = require('./components/campaigns/List.vue').default;
var campaignShow = require('./components/campaigns/Show.vue').default;
var campaignEdit = require('./components/campaigns/Edit.vue').default;


var logList = require('./components/log/LogListNew.vue').default;
var logShow  = require( './components/generic/GenericShow.vue').default;

var feedbackList = require('./components/feedback/FeedbackList.vue').default;
var feedbackShow  = require( './components/feedback/FeedbackShow.vue').default;

// var isabel = require('./components/patient/Isabel.vue').default;
var formSubmission = require('./components/forms/FormSubmission.vue').default;

var userGroupList = require('./components/generic/GenericList.vue').default;
var userGroupShow  = require( './components/generic/GenericShow.vue').default;
var userGroupEdit  = require( './components/generic/GenericEdit.vue').default;

var threadList = require('./components/thread/ThreadListNew.vue').default;
var threadShow  = require( './components/message/MessageList.vue').default;
var failedFilingList = require('./components/thread/FailedFilingList.vue').default;

var staffProfile  = require( './components/StaffProfile.vue').default;

var presetMessageList = require('./components/generic/GenericList.vue').default;
var presetMessageShow  = require( './components/generic/GenericShow.vue').default;
var presetMessageEdit  = require( './components/generic/GenericEdit.vue').default;

var loginForm = require('./components/generic/auth/Login.vue').default;
var logout = require('./components/patient/Logout.vue').default;
var forgottenPasswordForm = require('./components/patient/ForgottenPassword.vue').default;


var gruveo  = require( './components/Gruveo.vue').default;

var dashboard  = require( './components/Dashboard.vue').default;
var capacityPlanning  = require( './components/CapacityPlanning.vue').default;
var providerHome  = require( './components/ProviderHome.vue').default;
var settings  = require( './components/Settings.vue').default;
var lab  = require( './components/Lab.vue').default;

var reports  = require( './components/reports/Reports.vue').default;
var diagnostics  = require( './components/Diagnostics.vue').default;
//var appLoading  = require( './components/AppLoading.vue').default;

var calendar = require('./components/bookings/provider/Calendar.vue').default;

var routes = [
    {
        path: '/thread-list',
        name: 'threadList',
        components: {
            content1: threadList
        },
        children: [{
            path: 'thread-show/:id/:archive?',
            components: {
                content2: threadShow
            },
            props: {
                content2: {
                    type: "edit",
                    event: "message",
                    model: "message",
                    elementname: "Messages",
                    apiRoute: '/api/v1'
                }
            }
        },
        {
            path: 'thread-create/:user_id?',
            components: {
                content2: threadShow
            },
            props: {
                content2: {
                    type: "create",
                    event: "message",
                    model: "message",
                    elementname: "Messages",
                    apiRoute: '/api/v1'
                }
            }
        },
        {
            path: 'thread-show/:id/:archive?/patient-inline-edit/:pid',
            name: 'threadPatientInline',
            components: {
                content2: patientEdit
            },
            props: {
                content2: {
                    type: 'edit',
                    event: "patient",
                    model: "user",
                    elementname: "Patient",
                    displayelement: "patient-edit",
                    route: '/api/v1/patients'
                }
            }
        }]
    },
    {
        path: '/filing-list',
        name: 'filingList',
        components: {
            content1: failedFilingList
        },
        props: {
            content1: {
                route: "/api/v1/threads/failed-filings"
            },
        },
        children: [{
            path: 'thread-show/:id/:archive?',
            components: {
                content2: threadShow
            },
            props: {
                content2: {
                    type: "edit",
                    event: "message",
                    model: "message",
                    elementname: "Messages",
                    apiRoute: '/api/v1'
                }
            },
            
        },
        {
            path: 'thread-show/:id/:archive?/patient-inline-edit/:pid',
            name: 'filingPatientInline',
            components: {
                content2: patientEdit
            },
            props: {
                content2: {
                    type: 'edit',
                    event: "patient",
                    model: "user",
                    elementname: "Patient",
                    displayelement: "patient-edit",
                    route: '/api/v1/patients'
                }
            }
        }]
    },
    // {
    //     path: '/user-list',
    //     components: {
    //         content1: userList
    //     },
    //     props: {
    //         content1: {
    //             modalid: "user-filter-modal",
    //             displayelement: "user-list",
    //             event: "user",
    //             model: "user",
    //             title: "Users",
    //             path: 'users',
    //             route: '/api/v1/users'
    //         }
    //     }
    // },
    //<generic-list modalid="staff-filter-modal" displayelement="staff-list" event="staff" model="user" title="Staff" path='staff' route='{{ route('api.v1.staff.index') }}'></generic-list>

    {
        path: '/staff-list',
        name: 'staffList',
        components: {
            content1: staffList
        },
        props: {
            content1: {
                modalid: "staff-filter-modal",
                displayelement: "staff-list",
                event: "staff",
                model: "user",
                title: "staff_members",
                path: 'staff',
                route: '/api/v1/staff'
            }
        },
        children: [{
            path: 'staff-show/:id',
            name: 'staffShow',
            components: {
                content2: staffShow
            },
            props: {
                content2: {
                    event: "staff",
                    model: "user",
                    elementname: "Staff Member",
                    displayelement: "staff-show",
                    route: '/api/v1/staff'
                }
            }
        },
        {
            path: 'staff-edit/:id/:tab?',
            name: 'staffEdit',
            components: {
                content2: staffEdit
            },
            props: {
                content2: {
                    type: 'edit',
                    event: "staff",
                    model: "user",
                    elementname: "Staff Member",
                    displayelement: "staff-edit",
                    route: '/api/v1/staff'
                }
            }
        },
        {
            path: 'staff-create',
            components: {
                content2: staffEdit
            },
            props: {
                content2: {
                    type: 'create',
                    event: "staff",
                    model: "user",
                    elementname: "Staff Member",
                    displayelement: "staff-edit",
                    route: '/api/v1/staff'
                }
            }
        }]
    },
    {
        path: '/usergroup-list',
        name: 'userGroupList',
        components: {
            content1: userGroupList
        },
        props: {
            content1: {
                modalid: "usergroup-filter-modal",
                displayelement: "usergroup-list",
                event: "usergroup",
                model: "usergroup",
                title: "user_groups",
                path: 'usergroups',
                route: '/api/v1/usergroups'
            }
        },
        children: [{
            path: 'usergroup-show/:id',
            components: {
                content2: userGroupShow
            },
            props: {
                content2: {
                    event: "usergroup",
                    model: "usergroup",
                    elementname: "User Group",
                    displayelement: "usergroup-show",
                    route: '/api/v1/usergroups'
                }
            }
        },
        {
            path: 'usergroup-edit/:id',
            components: {
                content2: userGroupEdit
            },
            props: {
                content2: {
                    type: 'edit',
                    event: "usergroup",
                    model: "usergroup",
                    elementname: "User Group",
                    displayelement: "usergroup-edit",
                    route: '/api/v1/usergroups'
                }
            }
        },
        {
            path: 'usergroup-create',
            components: {
                content2: userGroupEdit
            },
            props: {
                content2: {
                    type: 'create',
                    event: "usergroup",
                    model: "usergroup",
                    elementname: "User Group",
                    displayelement: "usergroup-edit",
                    route: '/api/v1/usergroups'
                }
            }
        }]
    },
    {
        path: '/userduplicate-list',
        name: 'userDuplicateList',
        components: {
            content1: userDuplicateList
        },
        props: {
            content1: {
                modalid: "userduplicate-filter-modal",
                displayelement: "userduplicate-list",
                event: "userduplicate",
                model: "userduplicate",
                title: "duplicate_patients",
                path: 'userduplicates',
                route: '/api/v1/userduplicates'
            }
        },
        children: [{
            path: 'userduplicate-show/:id',
            components: {
                content2: userDuplicateShow
            },
            props: {
                content2: {
                    event: "userduplicate",
                    model: "userduplicate",
                    elementname: "Duplicate Patient Details",
                    displayelement: "userduplicate-show",
                    route: '/api/v1/userduplicates'
                }
            }
        },
        {
            path: 'userduplicate-edit/:id',
            components: {
                content2: userDuplicateEdit
            },
            props: {
                content2: {
                    type: 'edit',
                    event: "userduplicate",
                    model: "userduplicate",
                    elementname: "Duplicate Patient Details",
                    displayelement: "userduplicate-edit",
                    route: '/api/v1/userduplicates'
                }
            }
        },
        {
            path: 'userduplicate-create',
            components: {
                content2: userDuplicateEdit
            },
            props: {
                content2: {
                    type: 'create',
                    event: "userduplicate",
                    model: "userduplicate",
                    elementname: "Duplicate Patient Details",
                    displayelement: "userduplicate-edit",
                    route: '/api/v1/userduplicates'
                }
            }
        }]
    },
    //<generic-list modalid="patient-filter-modal" displayelement="patient-list" event="patient" model="user" title="Patients" path='patients' route='{{ route('api.v1.patients.index') }}'></generic-list> --}}

    {
        path: '/patient-list',
        name: 'patientList',
        components: {
            content1: patientList
        },
        props: {
            content1: {
                modalid: "patient-filter-modal",
                displayelement: "patient-list",
                event: "patient",
                model: "user",
                //title: "patient_search", // Note this is now in the translations.php file
                titleBrandKey: "Clients", // Note this is now in the translations.php file
                path: 'patients',
                route: '/api/v1/patients'
            }
        },
        children: [{
            path: 'patient-show/:id',
            components: {
                content2: patientShow
            },
            props: {
                content2: {
                    event: "patient",
                    model: "user",
                    elementname: "Patient",
                    displayelement: "patient-show",
                    route: '/api/v1/patients'
                }
            }
        },
        {
            path: 'patient-edit/:id',
            name: "patientEdit",
            components: {
                content2: patientEdit
            },
            props: {
                content2: {
                    type: 'edit',
                    event: "patient",
                    model: "user",
                    elementname: "Patient",
                    displayelement: "patient-edit",
                    route: '/api/v1/patients'
                }
            }
        },
        {
            path: 'patient-create',
            components: {
                content2: patientEdit
            },
            props: {
                content2: {
                    type: 'create',
                    event: "patient",
                    model: "user",
                    elementname: "Client",
                    displayelement: "patient-edit",
                    route: '/api/v1/patients'
                }
            }
        }]
    },
    {
        path: '/capacity-planning',
        name: 'CapacityPlanning',
        components: {
            content1: capacityPlanning
        },
        props: {
            content1: {

            }
        }
    },
    {
        path: '/lab',
        name: 'Lab',
        components: {
            content1: lab
        },
        props: {
            content1: {

            }
        }
    },
    {
        path: '/staff-profile',
        name: 'StaffProfile',
        components: {
            content1: staffProfile
        },
        props: {
            content1: {

            }
        }
    },
    {
        path: '/presetmessage-list',
         name: 'presetMessageList',
         components: {
             content1: presetMessageList
        },
        props: {
            content1: {
                modalid: "presetmessage-filter-modal",
                displayelement: "presetmessage-list",
                event: "presetmessage",
                model: "presetmessage",
                title: "preset_messages",
                path: 'presetmessage',
                route: '/api/v1/presetmessage',
            }
        },

        children: [{
            path: 'presetmessage-show/:id',
            components: {
                content2: presetMessageShow
            },
            props: {
                content2: {
                    event: "presetmessage",
                    model: "presetmessage",
                    elementname: "Preset Message",
                    displayelement: "presetmessage-show",
                    route: '/api/v1/presetmessage'
                }
            }
        },
        {
            path: 'presetmessage-edit/:id',
            components: {
                content2: presetMessageEdit
            },
            props: {
                content2: {
                    type: 'edit',
                    event: "presetmessage",
                    model: "presetmessage",
                    elementname: "Preset Message Item",
                    displayelement: "presetmessage-edit",
                    route: '/api/v1/presetmessage'
                }
            }
        },
        {
            path: 'presetmessage-create',
            components: {
                content2: presetMessageEdit
            },
            props: {
                content2: {
                    type: 'create',
                    event: "presetmessage",
                    model: "presetmessage",
                    elementname: "Preset Message Item",
                    displayelement: "presetmessage-edit",
                    route: '/api/v1/presetmessage'
                }
            }
        }]

    },

    {
        path: '/dashboard',
        name: 'Dashboard',
        components: {
            content1: dashboard
        },
        props: {
            content1: {

            }
        }
    },
    {
        path: '/home',
        name: 'Home',
        components: {
            content1: providerHome
        },
        props: {
            content1: {

            }
        }
    },
    {
        path: '/appointments',
        name: 'Appointments',
        components: {
            content1: calendar
        },
        props: {
            content1: {

            }
        }
    },
    {
        path: '/settings',
        name: 'Settings',
        components: {
            content1: settings
        },
        props: {
            content1: {

            }
        }
    },

    // {
    //     path: '/isabel',
    //     name: 'Isabel',
    //     components: {
    //         content1: isabel
    //     },
    //     props: {
    //         content1: {
    //             showFooter: false,
    //         }
    //     }
    // },
    {
        path: '/login/:next?/:message?',
        name: 'loginForm',
        components: {
            content1: loginForm
        },
        props: {
            content1: {
                postLoginRoute: "home",
                staff: true
            }
        }
    },
    {
        path: '/logout',
        name: 'logout',
        components: {
            content1: logout
        },
    },
    {
        path: '/password-reset/:next?/:token?/:email?/:new?',
        name: 'forgottenPasswordForm',
        components: {
            content1: forgottenPasswordForm
        },
        props: {
            content1: {
                staff: true
            }
        }
    },
    {
        path: '/form-submission/:id/:archive?',
        name: 'formSubmission',
        components: {
            content1: formSubmission
        },
        meta: {
            title: 'Form'
        }
    },

    {
        path: '/reports',
        name: 'Reports',
        components: {
            content1: reports
        },
        props: {
            content1: {

            }
        }
    },
    {
        path: '/diagnostics',
        name: 'Diagnostics',
        components: {
            content1: diagnostics
        },
        props: {
            content1: {

            }
        }
    },
    // {
    //     path: '/loading',
    //     name: 'Loading',
    //     components: {
    //         content1: appLoading
    //     },
    //     props: {
    //         content1: {
    //
    //         }
    //     }
    // },
    {
        path: '/news-list',
        name: 'newsList',
        components: {
            content1: newsList
        },
        props: {
            content1: {
                modalid: "news-filter-modal",
                displayelement: "news-list",
                event: "news",
                model: "news",
                title: "news_items",
                path: 'news',
                route: '/api/v1/news'
            }
        },
        children: [{
            path: 'news-show/:id',
            components: {
                content2: newsShow
            },
            props: {
                content2: {
                    event: "news",
                    model: "news",
                    elementname: "News Item",
                    displayelement: "news-show",
                    route: '/api/v1/news'
                }
            }
        },
        {
            path: 'news-edit/:id',
            components: {
                content2: newsEdit
            },
            props: {
                content2: {
                    type: 'edit',
                    event: "news",
                    model: "news",
                    elementname: "News Item",
                    displayelement: "news-edit",
                    route: '/api/v1/news'
                }
            }
        },
        {
            path: 'news-create',
            components: {
                content2: newsEdit
            },
            props: {
                content2: {
                    type: 'create',
                    event: "news",
                    model: "news",
                    elementname: "News Item",
                    displayelement: "news-edit",
                    route: '/api/v1/news'
                }
            }
        }]
    },
    {
        path: '/log-list',
        name: 'logList',
        components: {
            content1: logList
        },
        children: [{
            path: 'log-show/:id',
            components: {
                content2: logShow
            },
            props: {
                content2: {
                    event: "log",
                    model: "log",
                    elementname: "Log Entry",
                    displayelement: "log-show",
                    route: '/api/v1/logs'
                }
            }
        }]
    },
    {
        path: '/feedback-list',
        name: 'feedbackList',
        components: {
            content1: feedbackList
        },
        props: {
            
        },
        children: [{
            path: 'feedback-show/:id',
            components: {
                content2: feedbackShow
            },
        }]
    },
    {
        path: '/tag-list',
        name: 'tagList',
        components: {
            content1: tagList
        },
        children: [{
            path: 'tag-show/:id',
            components: {
                content2: tagShow
            },
        },
        {
            path: 'tag-edit/:id',
            components: {
                content2: tagEdit
            },
        },
        {
            path: 'tag-create',
            components: {
                content2: tagEdit
            },
        }]
    },
    {
        path: '/custom_action-list',
        name: 'customAction',
        components: {
            content1: customActionList
        },
        children: [{
            path: 'custom_action-show/:id',
            components: {
                content2: customActionShow
            },
        },
        {
            path: 'custom_action-edit/:id',
            components: {
                content2: customActionEdit
            },
        },
        {
            path: 'custom_action-create',
            components: {
                content2: customActionEdit
            },
        }]
    },
    {
        path: '/cohort-list',
        name: 'cohort',
        components: {
            content1: cohortList
        },
        children: [{
            path: 'cohort-show/:id',
            components: {
                content2: cohortShow
            },
        },
        {
            path: 'cohort-edit/:id',
            components: {
                content2: cohortEdit
            },
        },
        {
            path: 'cohort-create',
            components: {
                content2: cohortEdit
            },
        }]
    },
    {
        path: '/campaign-list',
        name: 'campaign',
        components: {
            content1: campaignList
        },
        children: [{
            path: 'campaign-show/:id',
            components: {
                content2: campaignShow
            },
        },
        {
            path: 'campaign-edit/:id',
            components: {
                content2: campaignEdit
            },
        },
        {
            path: 'campaign-create',
            components: {
                content2: campaignEdit
            },
        }]
    },
];

export default routes
